import React from 'react';
import {
  Modal,
  ModalContent,
  Text,
  Space,
  Button,
} from '@cashfree-intl/coherent';
import { CURRENCY_SYMBOL } from 'utils/constants';
import {
  StyledFooter,
  ActivationModalContent,
  StyledPricingDiv,
  StyledPricingDescription,
  StyledCross,
  StyledISActivationNote,
} from './styled';

const InstantRefundActivationModal = ({ data, onConfirm, closeModal }: any) => {
  const { instantRefundRates, freeCreditsLeft } = data;

  return (
    <Modal $maxWidth={420} open>
      {/* <ModalHeader>
        Instant Refund Activation{' '}
        <Cross
          size="sm"
          onClick={closeModal}
          data-event-name="InstantRefundActivationModal_Icon_Close"
          data-ignore-inner-text="true"
        />
      </ModalHeader> */}
      <ModalContent className="p-0">
        <ActivationModalContent>
          <div className="pricing-header pt-3 position_relative">
            <StyledCross
              size="md"
              stroke="white"
              onClick={closeModal}
              data-event-name="InstantRefundActivationModal_Icon_Close"
              data-ignore-inner-text="true"
            />
            <Text color="white" strong className="pricing-heading">
              Instant Refund Activation
            </Text>
            <Text variant="b12" className="pricing-description">
              To enhance your customers&apos; experience with lightning-fast{' '}
              <br />
              refunds, a nominal fee will be applied after your{' '}
              <span className="bold">{freeCreditsLeft} free trials.</span>
            </Text>
          </div>
          <StyledPricingDiv className="position_relative">
            <Text variant="b10" color="placeholder">
              You will be charged:
            </Text>
            <Space alignItems="center" justifyContent="space-between">
              <Space alignItems="end" gap={0.25}>
                <Text variant="h20" color="primary">
                  {CURRENCY_SYMBOL.INR}
                  {instantRefundRates?.fixedRate}
                </Text>
                <Text variant="b14">+</Text>
                <Text variant="b14">GST</Text>
              </Space>
              <Text variant="b12" className="w-500">
                per Instant Refund
              </Text>
            </Space>
          </StyledPricingDiv>
          <StyledPricingDescription variant="b14" color="bodyLight">
            The pricing will apply to Instant Refunds on UPI transactions.
          </StyledPricingDescription>
          <div className="text-center">
            <Button
              fluid
              primary
              role="button"
              className="confirm-activation-button"
              onClick={onConfirm}
              data-event-name="Primary_Button_Confirm_Activation"
              data-ignore-inner-text="true"
            >
              Confirm Activation
            </Button>
          </div>
          <StyledISActivationNote variant="b12" color="bodyLight" className="mt-1 mb-4">
            Instant refunds will be processed to the original payment source via a new transaction.
          </StyledISActivationNote>
        </ActivationModalContent>
        <StyledFooter className="px-3">
          <Text variant="b12" className="w-400">
            You can switch back to the standard refunds anytime from settings.
          </Text>
        </StyledFooter>
      </ModalContent>
    </Modal>
  );
};

export default InstantRefundActivationModal;
